var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1875 7.35727C17.1875 10.6854 15.1771 13.5416 12.5 13.5416C9.82082 13.5416 7.81248 10.6854 7.81248 7.35623C7.81248 4.02915 9.54165 2.08331 12.5 2.08331C15.4583 2.08331 17.1875 4.0281 17.1875 7.35727ZM4.2729 20.9812C4.67394 21.4583 6.40102 22.9166 12.5 22.9166C18.5989 22.9166 20.325 21.4583 20.7271 20.9823C20.7644 20.9365 20.7919 20.8836 20.808 20.8268C20.8242 20.7701 20.8285 20.7106 20.8208 20.6521C20.7291 19.7333 19.9021 15.625 12.5 15.625C5.0979 15.625 4.27082 19.7333 4.17811 20.6521C4.17056 20.7107 4.17508 20.7702 4.19138 20.827C4.20768 20.8837 4.23542 20.9356 4.2729 20.9812Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile3.3986b9d480efe0c0c1ba72e06f9e1311.svg";
export { ForwardRef as ReactComponent };